<template>
    <v-container fluid class="mr-10">
        <v-row>
            <v-col class="d-flex" cols="12" sm="6">
                <p class="text-h3">{{$t('message.my_orders')}}</p>
            </v-col>
		</v-row>
        <v-row>
            <v-col cols="2"></v-col>
            <v-col cols="10" v-if="orders.length > 0">
                <Order  v-for="order in orders" v-bind:item="order" v-bind:key="order.id" :order="order"></Order>
            </v-col>
            <v-col cols="10" v-if="orders.length == 0">
                Nenhum pedido encontrado
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Order from '../components/cart/Order';
    import API from '../services/Api';
    import parser from  "../utils/parser";
    export default {
        components:{
            'Order' : Order
        },
        data: () => ({
            orders: []
        }),        
        mounted(){            
            var token = this.$store.state.auth.token;
            API.getMyOrders(token)
                .then(response=>{
                    this.orders = parser.getMyOrdersToOrders(response);
                })
                .catch(err=>{
                    console.log(err);
                });            
        }
    }
</script>